/**
 * UI Library Page - UI Component
 *
 * Internal showcase for design tokens and shared UI components.
 *
 * @layer pages
 * @slice ui-library
 * @segment ui
 */

import { useTranslation } from 'react-i18next';

import { UILibraryLayout } from './layout/UILibraryLayout';
import { DataDisplaySection } from './sections/DataDisplaySection';
import { DesignTokensSection } from './sections/DesignTokensSection';
import { FeedbackSection } from './sections/FeedbackSection';
import { FormsSection } from './sections/FormsSection';
import { IconsSection } from './sections/IconsSection';
import { LayoutSection } from './sections/LayoutSection';
import { NavigationSection } from './sections/NavigationSection';
import { OverlaySection } from './sections/OverlaySection';
import { PatternsSection } from './sections/PatternsSection';
import { PrimitivesSection } from './sections/PrimitivesSection';
import { UI_LIBRARY_SECTIONS } from './ui-library-sections';

interface UILibraryPageProps {
  /** Current locale from route params */
  locale: string;
}

export function UILibraryPage({ locale }: UILibraryPageProps) {
  const { t } = useTranslation();

  return (
    <>
      <title>{`${t('uiLibrary.title')} | Molchanovs Move`}</title>
      <meta name="robots" content="noindex" />
      <meta name="content-language" content={locale} />

      <UILibraryLayout
        sections={UI_LIBRARY_SECTIONS}
        sectionContent={{
          tokens: <DesignTokensSection />,
          primitives: <PrimitivesSection />,
          icons: <IconsSection />,
          feedback: <FeedbackSection />,
          layout: <LayoutSection />,
          overlay: <OverlaySection />,
          navigation: <NavigationSection />,
          'data-display': <DataDisplaySection />,
          forms: <FormsSection />,
          patterns: <PatternsSection />,
        }}
      />
    </>
  );
}
